import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createNewJob, deleteJob, getJobsAsync, updateJob } from "./jobsAPI";

const sliceName = "jobs";
const initialState = {
    jobs: [],
    isLoading: false,
    isError: false,
    errorMessage: ''
};

export const fetchJobs = createAsyncThunk(`${sliceName}/fetchJobs`, getJobsAsync);

export const createJob = createAsyncThunk(`${sliceName}/createJob`, createNewJob);
export const editJob = createAsyncThunk(`${sliceName}/editJob`, updateJob);
export const removeJob = createAsyncThunk(`${sliceName}/deleteJob`, deleteJob);

const jobsSlice = createSlice({
    name: sliceName,
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.jobs = action.payload;
                state.isLoading = false;
                state.isError = false;
                state.errorMessage = '';
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.isError = true;
                state.errorMessage = action.error?.message;
                state.isLoading = false;
                state.jobs = [];
            });

        // CREATE JOB
        builder
            .addCase(createJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(createJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.jobs.push(action.payload);
            })
            .addCase(createJob.rejected, (state, action) => {
                state.isError = true;
                state.isLoading = false;
                state.errorMessage = action.error?.message;
            });
        
        // UPDATE JOB
        builder
            .addCase(editJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(editJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                const indexToUpdate = state.jobs.findIndex(
                    (j) => j.id === action.payload.id
                );

                state.jobs[indexToUpdate] = action.payload;
            })
            .addCase(editJob.rejected, (state, action) => {
                state.isError = true;
                state.isLoading = false;
                state.errorMessage = action.error?.message;
            });

        // DELETE JOB
        builder
            .addCase(removeJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(removeJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                
                state.jobs = state.jobs.filter(j => j.id !== action.meta.arg);
            })
            .addCase(removeJob.rejected, (state, action) => {
                state.isError = true;
                state.isLoading = false;
                state.errorMessage = action.error?.message;
            });
    }
});

export default jobsSlice.reducer;